import { useResourceDurationSlotGenerator, useResourceSlotGenerator } from '../../../hooks';
import { useDebouncedValue } from '@mantine/hooks';
import { IUseSlotGenerator } from './types';
import { SlotsTypeEnum } from '@jooxter/api';
import { IQuickTimeSlot } from '@jooxter/utils';

export const useSlotGenerator = ({
  isoStartDate,
  isoEndDate,
  resourceId,
  timezone,
  seatRequested,
  bookingMask,
  defaultSlots,
  slotType,
}: IUseSlotGenerator): { slots: IQuickTimeSlot[]; isLoading: boolean } => {
  const { slots: classicSlots, isLoading: isResourceSlotLoading } = useResourceSlotGenerator({
    start: isoStartDate,
    end: isoEndDate,
    options: {
      resourceId,
      timezone: timezone,
      seatRequested,
      bookingMask,
    },
  });
  const { durationSlots, isLoading: isResourceDurationSlotLoading } = useResourceDurationSlotGenerator({
    date: isoStartDate,
    options: {
      resourceId,
      slots: defaultSlots,
      timezone: timezone,
      seatRequested,
      bookingMask,
    },
  });

  const [slots] = useDebouncedValue(slotType === SlotsTypeEnum.Duration ? durationSlots : classicSlots, 300);
  const isLoading = slotType === SlotsTypeEnum.Duration ? isResourceDurationSlotLoading : isResourceSlotLoading;

  return { slots, isLoading };
};
